import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateQuestion extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Question/Create");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}
class GetAllQuestions extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Question/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}
class UpdateQuestion extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Question/Update");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}
class GetAQuestion extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Question/GetBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}
class DeleteAQuestion extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Question/DeleteBy");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetRandomQuestionsForExam extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Question/GetRandomQuestionsForExam");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetQuestionListBy extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Question/GetListBy");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  CreateQuestion,
  GetAllQuestions,
  UpdateQuestion,
  GetAQuestion,
  DeleteAQuestion,
  GetRandomQuestionsForExam,
  GetQuestionListBy,
};
